import {createReducer} from "redux-act";
import {IPredictionReducer} from "modules/types";
import {
	fetchLeaderBoard,
	clearLeaderBoard,
	clearPredictionSavedState,
	clearPredictionState,
	fetchGameBarSuccess,
	fetchLeaderBoardSuccess,
	fetchUserPredictionSuccess,
	postPredictorPrediction,
	postPredictorPredictionSuccess,
	setTimerState,
} from "modules/actions";
import {RequestStateType} from "modules/utils";

const initialState = {
	is_result_saving: false,
	is_result_saved: false,
	timer_ended: false,
	time_input_length: {
		minutes: 1,
		seconds: 2,
		milliseconds: 3,
	},
	user_prediction: {
		prediction: null,
		question: {
			id: 0,
			eventId: 0,
			locked: false,
		},
	},
	game_bar: {
		eventName: "",
		eventPoints: null,
		eventRank: null,
		startRace: "",
		overallPoints: null,
		overallRank: null,
	},
	leaderboard: {
		rankings: [],
		nextPage: false,
		user: null,
	},
	leaderboardRequest: RequestStateType.IDLE,
};

export const predictor = createReducer<IPredictionReducer>({}, initialState)
	.on(fetchUserPredictionSuccess, (state, payload) => ({
		...state,
		user_prediction: payload,
	}))
	.on(postPredictorPrediction, (state) => ({
		...state,
		is_result_saving: true,
	}))
	.on(postPredictorPredictionSuccess, (state, payload) => ({
		...state,
		is_result_saved: true,
		is_result_saving: false,
		user_prediction: {
			...payload,
		},
	}))
	.on(clearPredictionSavedState, (state) => ({
		...state,
		is_result_saved: false,
	}))
	.on(clearPredictionState, (state) => ({
		...state,
		is_result_saved: false,
		user_prediction: {
			prediction: null,
			question: {
				id: 0,
				eventId: 0,
				locked: false,
			},
		},
	}))
	.on(setTimerState, (state, payload) => ({
		...state,
		timer_ended: payload,
	}))
	.on(fetchGameBarSuccess, (state, payload) => ({
		...state,
		game_bar: {
			...payload,
		},
	}))
	.on(fetchLeaderBoard, (state) => ({
		...state,
		leaderboardRequest: RequestStateType.Requested,
	}))
	.on(fetchLeaderBoardSuccess, (state, payload) => ({
		...state,
		leaderboard: {
			...payload,
		},
		leaderboardRequest: RequestStateType.Received,
	}))
	.on(clearLeaderBoard, (state) => ({
		...state,
		leaderboard: {
			rankings: [],
			nextPage: false,
			user: null,
		},
	}));
